<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
import List from './invoice.partner.List.i18n';
import Detail from './invoice.partner.Detail.18n';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag, invoice_id }) {
      if(!id && !invoice_id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('Invoice.vue', 'route changed', to.param, from);
      this.select(to.params);
    }
  },
  created: function() { console.log('Invoice.vue', 'created'); },
  destroyed: function() { console.log('Invoice.vue', 'destroyed'); },
  mounted: function() {
    console.log('Invoice.vue', 'mounted');
    this.select(this.$route.params);
  },
}
</script>
